import type { DropdownLink } from './Desktop/NavDropdown';

/**
 * Hand-built vertical pages that live directly under `pages/industry/<slug>/`
 * (bypassing Strapi entirely) instead of going through the CMS-driven
 * `[verticalSlug].tsx` route. Next.js resolves the static file over the
 * dynamic route automatically, so nothing else is needed to make such a page
 * work — this registry only makes it show up in the nav, keyed by the
 * Industry's slug, alongside that industry's CMS verticals.
 *
 * Example:
 * manufacturing: [
 *   { label: 'Custom Vertical', href: '/industry/manufacturing/custom-slug', linkType: 'internal' },
 * ],
 */
export const customVerticalLinks: Record<string, DropdownLink[]> = {};
